import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const tabs = [
  {
    id: "ue",
    label: "Cittadini Italiani e UE",
    items: [
      "Compimento del 18° anno di età",
      "Licenza media (assolvimento dell'obbligo scolastico / istruzione secondaria di primo grado)",
    ],
  },
  {
    id: "extra",
    label: "Cittadini Extra-UE",
    items: [
      "Titolo di studio equipollente (licenza media o superiore) con Dichiarazione di Valore consolare o attestazione CIMEA",
      "Certificazione di conoscenza della lingua italiana livello minimo B1 QCER (o titolo di studio conseguito in Italia)",
      "Regolare Permesso di Soggiorno in corso di validità",
    ],
  },
];

export default function Requisiti() {
  const [active, setActive] = useState("ue");
  const current = tabs.find((t) => t.id === active);

  return (
    <section id="requisiti" className="border-t border-line bg-navy py-16 text-white md:py-24" data-testid="requisiti-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs font-medium uppercase tracking-[0.25em] text-brand-amber" data-testid="requisiti-eyebrow">
            Requisiti di accesso
          </p>
          <h2 className="mt-4 max-w-3xl font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl" data-testid="requisiti-title">
            Cosa serve per iscriversi al corso
          </h2>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="requisiti-tabs">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => setActive(t.id)}
              className={`border px-5 py-3 font-heading text-sm font-bold transition-colors ${
                active === t.id
                  ? "border-brand-amber bg-brand-amber text-navy-deep"
                  : "border-white/25 bg-transparent text-white hover:border-white hover:bg-white/10"
              }`}
              data-testid={`requisiti-tab-${t.id}`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.35 }}
            className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3"
            data-testid={`requisiti-panel-${active}`}
          >
            {current.items.map((item) => (
              <div key={item} className="flex gap-3 border border-white/15 bg-white/5 p-6 backdrop-blur-sm">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-brand-amber" />
                <p className="text-sm leading-relaxed text-slate-200">{item}</p>
              </div>
            ))}
          </motion.div>
        </AnimatePresence>

        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-sm text-slate-400" data-testid="requisiti-note">
            Non sei sicuro di avere i requisiti, o hai un titolo equipollente (es. diploma alberghiero)?
            Contattaci: verifichiamo gratuitamente la tua posizione e le eventuali esenzioni.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
